import { useEffect, useState } from 'react'

import Lottie from 'lottie-react'
import { Button, Table } from 'react-bootstrap'
import {
  ArrowClockwise,
  KeyFill,
  PencilFill,
  PersonFillAdd,
  TrashFill,
} from 'react-bootstrap-icons'
import { CustomSpinner } from '../../components/CustomSpinner'

import NetworkErrorAnimation from '../../assets/lottie/network-error.json'
import Navbar from '../../components/navbar/navbar'

import FuncionariosService from '../../services/database/FuncionariosService'

import { CustomButton } from '../../components/CustomButton'
import { ModalCadFunc } from './ModalCadFunc'
import { ModalDelFunc } from './ModalDelFunc'
import { ModalEditFunc } from './ModalEditFunc'
import { ModalResetSenhaFunc } from './ModalResetSenhaFunc'

import './styles.css'

export function Funcionarios() {
  const [isModalCadFuncVisible, setIsModalCadFuncVisible] = useState(false)
  const [isModalEditFuncVisible, setIsModalEditFuncVisible] = useState(false)
  const [isModalResetSenhaFuncVisible, setIsModalResetSenhaFuncVisible] =
    useState(false)
  const [isModalDelFuncVisible, setIsModalDelFuncVisible] = useState(false)

  const [selectedFuncId, setSelectedFuncId] = useState('')
  const [funcionarios, setFunctionarios] = useState([])
  const [isFuncionariosLoading, setIsFuncionariosLoading] = useState(true)
  const [hasError, setHasError] = useState(false)

  async function loadFuncionarios() {
    setIsFuncionariosLoading(true)

    try {
      const funcionarios = await FuncionariosService.getAll()

      setFunctionarios(funcionarios)
      setHasError(false)
    } catch (err) {
      console.log(`Erro ao carregar dados dos funcionários:`, err)
      setHasError(true)
    } finally {
      setIsFuncionariosLoading(false)
    }
  }

  useEffect(() => {
    loadFuncionarios()
  }, [])

  return (
    <>
      <Navbar />

      <div className="mt-page">
        <h1>Listagem de Funcionários</h1>

        <div className="buttons-upon">
          <CustomButton
            title="Cadastrar"
            onClick={() => setIsModalCadFuncVisible(true)}
          >
            <PersonFillAdd />
          </CustomButton>

          <CustomButton
            title="Atualizar"
            onClick={loadFuncionarios}
          >
            <ArrowClockwise />
          </CustomButton>
        </div>

        <div id="container-center">
          {isFuncionariosLoading ? (
            <CustomSpinner />
          ) : hasError ? (
            <>
              <Lottie
                animationData={NetworkErrorAnimation}
                loop
                autoplay
                style={{
                  width: 350,
                  height: 350,
                }}
              />

              <Button
                size="lg"
                onClick={loadFuncionarios}
              >
                <ArrowClockwise />
                Tentar Novamente
              </Button>
            </>
          ) : (
            <Table
              striped
              bordered
              hover
            >
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Nome do funcionário</th>
                  <th>CPF</th>
                  <th>Fone Fixo</th>
                  <th>Celular</th>
                  <th style={{ textAlign: 'center' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {funcionarios.map((funcionario) => (
                  <tr key={funcionario.IDFUNCIONARIO}>
                    <td>{funcionario.IDFUNCIONARIO}</td>
                    <td>{funcionario.NOMEFUNCIONARIO}</td>
                    <td>{funcionario.CPF}</td>
                    <td>{funcionario.RG}</td>
                    <td>{funcionario.FONECELULAR}</td>
                    <td>
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Button
                          title="Editar Funcionário"
                          variant="warning"
                          size="sm"
                          onClick={() => {
                            setSelectedFuncId(funcionario.IDFUNCIONARIO)
                            setIsModalEditFuncVisible(true)
                          }}
                        >
                          <PencilFill />
                        </Button>
                        <Button
                          title="Deletar Funcionário"
                          variant="danger"
                          size="sm"
                          onClick={() => {
                            setSelectedFuncId(funcionario.IDFUNCIONARIO)
                            setIsModalDelFuncVisible(true)
                          }}
                        >
                          <TrashFill />
                        </Button>

                        <Button
                          title="Redefinir Senha"
                          size="sm"
                          onClick={() => {
                            setSelectedFuncId(funcionario.IDFUNCIONARIO)
                            setIsModalResetSenhaFuncVisible(true)
                          }}
                        >
                          <KeyFill />
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </div>

      {isModalCadFuncVisible && (
        <ModalCadFunc
          isOpen={isModalCadFuncVisible}
          onClose={() => setIsModalCadFuncVisible(false)}
          loadFuncionarios={loadFuncionarios}
        />
      )}

      {isModalEditFuncVisible && (
        <ModalEditFunc
          funcId={selectedFuncId}
          isOpen={isModalEditFuncVisible}
          onClose={() => setIsModalEditFuncVisible(false)}
          loadFuncionarios={loadFuncionarios}
        />
      )}

      {isModalDelFuncVisible && (
        <ModalDelFunc
          funcId={selectedFuncId}
          isOpen={isModalDelFuncVisible}
          onClose={() => setIsModalDelFuncVisible(false)}
          loadFuncionarios={loadFuncionarios}
        />
      )}

      {isModalResetSenhaFuncVisible && (
        <ModalResetSenhaFunc
          funcId={selectedFuncId}
          isOpen={isModalResetSenhaFuncVisible}
          onClose={() => setIsModalResetSenhaFuncVisible(false)}
        />
      )}
    </>
  )
}
